import { cacheTypes, getMethodByCallBack, postMethodByCallBack } from "../../../store/api/CommonFunctions";

export function getInfoTypeList(onGet)
{
    getMethodByCallBack('api/BaseInfoAPI/GetInfoTypeList',cacheTypes.NoCache, onGet, "GetInfoTypeList");
}
/**
 * 
 * @param {bigint} typeID 
 * @param {function} onGet 
 */
export function getBaseInfoList(typeID, onGet)
{
    getMethodByCallBack(`api/BaseInfoAPI/GetBaseInfoList?typeID=${typeID}`, cacheTypes.NoCache, onGet, "GetBaseInfoList");
}
export function addBaseInfo(data, onAdd)
{
    postMethodByCallBack(`api/BaseInfoAPI/AddBaseInfo`, data, onAdd, "AddBaseInfo");
}
export function editBaseInfo(id, name, onEdit)
{
    getMethodByCallBack(`api/BaseInfoAPI/EditBaseInfo?id=${id}&name=${name}`, cacheTypes.NoCache, onEdit, "EditBaseInfo");
}